import { graphql } from "react-relay";

export const QUERY = graphql`
	query createLicensesForm_Query($first: Int, $after: String, $nameMatchRegex: String) {
		...createLicensesForm_QueryFragment
			@arguments(
				first: $first
				after: $after
				nameMatchRegex: $nameMatchRegex
				dataKinds: [Flex]
			)
	}
`;

export const QUERY_FRAGMENT = graphql`
	fragment createLicensesForm_QueryFragment on Query
	@refetchable(queryName: "createLicensesForm_Refetch")
	@argumentDefinitions(
		first: { type: "Int", defaultValue: 20 }
		after: { type: "String" }
		nameMatchRegex: { type: "String" }
		dataKinds: { type: "[LicenseDefinitionDataKind!]", defaultValue: [Flex] }
	) {
		Admin {
			LicenseDefinition {
				SearchLicenseDefinitions(
					first: $first
					after: $after
					nameMatchRegex: $nameMatchRegex
					dataKinds: $dataKinds
				) @connection(key: "createLicensesForm_SearchLicenseDefinitions") {
					__id
					pageInfo {
						endCursor
						hasPreviousPage
						hasNextPage
						startCursor
					}
					edges {
						node {
							id
							...selectLicenseDefinitionField_LicenseDefinitionFragment
						}
					}
				}
			}
		}
	}
`;
